const initialState = {
  indicators: [],
  events: [],
  guardianEvents: [],
  selectedEventId: null,
  reminders: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'STUDENT_DASHBOARD.POPULATE_STUDENT_INDICATORS':
      return {
        ...state,
        indicators: action.indicators,
      };
    case 'STUDENT_DASHBOARD.POPULATE_STUDENT_EVENTS':
      return {
        ...state,
        events: action.events,
      };
    case 'STUDENT_DASHBOARD.POPULATE_GUARDIAN_EVENTS':
      return {
        ...state,
        guardianEvents: action.guardianEvents,
      };
    case 'STUDENT_DASHBOARD.SET_SELECTED_EVENT_ID':
      return {
        ...state,
        selectedEventId: action.eventId,
      };
    case 'STUDENT_DASHBOARD.POPULATE_STUDENT_REMINDERS':
      return {
        ...state,
        reminders: action.reminders,
      };
    case 'STUDENT_DASHBOARD.POPULATE_STUDENT_SINGLE_INDICATOR':
      return {
        ...state,
        indicators: state.indicators.map(entry => {
          if (entry.indicator.uuid === action.indicator.indicator.uuid) {
            return action.indicator;
          }
          return entry;
        }),
      };
    case 'STUDENT_DASHBOARD.POPULATE_STUDENT_SINGLE_INDICATOR_PREEMPT':
      return {
        ...state,
        indicators: state.indicators.map(entry => {
          if (entry.indicator.uuid === action.indicatorUuid) {
            return {
              ...entry,
              customCompletedBy: new Date().toUTCString(),
              ...action.payload,
            };
          }
          return entry;
        }),
      };
    default:
      return state;
  }
};
